import React, { useState } from 'react';
import { Modal, Nav, Tab } from 'react-bootstrap';
import { css } from 'twin.macro';
import EmailBroadcastContainer from '../EmailBroadcast/EmailBroadcastContainer';
import EmailDraftContainer from './EmailDraftContainer';

const modalBodyStyle = css`
    min-height: 80vh;
`;

const EmailCommandModal = ({ show, onClose, chatroomId, teamId }) => {
    const [activeKey, setActiveKey] = useState('email-broadcast-drafts');

    return (
        <Modal show={show} onHide={() => onClose?.(false)} size="lg" centered>
            <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
                <Modal.Body className="p-0" css={modalBodyStyle}>
                    <Nav variant="tabs" className="px-3 pt-2">
                        <Nav.Item>
                            <Nav.Link eventKey="email-broadcast-drafts">
                                <strong>Email Broadcast Drafts</strong>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="email-drafts">
                                <strong>AI Email Drafts</strong>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <div className="px-3 pb-2">
                        <Tab.Content>
                            <Tab.Pane eventKey="email-broadcast-drafts">
                                {activeKey === 'email-broadcast-drafts' && (
                                    <EmailBroadcastContainer teamId={teamId} onClose={onClose} />
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="email-drafts">
                                {activeKey === 'email-drafts' && <EmailDraftContainer chatroomId={chatroomId} />}
                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                </Modal.Body>
            </Tab.Container>
        </Modal>
    );
};

export default EmailCommandModal;
